import api, { SUBJECTS_URL } from "./api";

export const fetchAllSubjects = async () => {
  return await api.get(`${SUBJECTS_URL}`);
};
